const GuatemalaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111542)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.9997 20.0008C39.9997 12.0716 35.3852 5.22035 28.6953 1.98535V38.0162C35.3852 34.7813 39.9997 27.93 39.9997 20.0008Z"
        fill="#338AF3"
      />
      <path
        d="M0 20.0008C0 27.93 4.61445 34.7813 11.3044 38.0163V1.98535C4.61445 5.22035 0 12.0716 0 20.0008Z"
        fill="#338AF3"
      />
      <path
        d="M25.2263 23.3809L21.8446 19.9992L25.0636 16.7801L24.9177 15.0799L23.9962 14.1582L19.9999 18.1545L16.0037 14.1582L15.0821 15.0799L14.9362 16.7801L18.1552 19.9992L14.7734 23.3809L16.6181 25.2255L19.9999 21.8438L23.3817 25.2255L25.2263 23.3809Z"
        fill="#ACABB1"
      />
      <path
        d="M24.9189 15.082L23.0743 16.9266C23.8611 17.7134 24.3478 18.8004 24.3478 20.001C24.3478 22.4023 22.4012 24.3488 20 24.3488C17.5988 24.3488 15.6521 22.4023 15.6521 20.001C15.6521 18.8004 16.1388 17.7134 16.9256 16.9266L15.081 15.082C13.8221 16.3408 13.0435 18.0799 13.0435 20.001C13.0435 23.843 16.158 26.9575 19.9999 26.9575C23.8419 26.9575 26.9564 23.843 26.9564 20.001C26.9564 18.08 26.1778 16.3409 24.9189 15.082Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111542">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GuatemalaSvg;
